import { languageID } from '@festina-life/fplus'
import { ThemeType } from '@festina-life/fplus-monaco'
import { WorkerPoolContextProvider } from '@pierre/diffs/react'
// oxlint-disable-next-line import/default
import DiffWorker from '@pierre/diffs/worker/worker.js?worker'
import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

/**
 * Diffs are highlighted and laid out on worker threads, so a long expression
 * never blocks the page it is shown on.
 *
 * The pool starts its workers and loads the highlighter the moment this exists,
 * and is torn down along with its caches once its last consumer unmounts. So it
 * belongs on a scope that outlives the individual diffs beneath it — currently
 * the template scene — and never inside one: diffs are shown in tooltips, and
 * mounting it there would rebuild the whole pool on every hover.
 */
export const FPlusDiffWorkerPoolProvider = ({ children }: Props) => (
  <WorkerPoolContextProvider
    poolOptions={{ workerFactory: () => new DiffWorker() }}
    highlighterOptions={{
      langs: [languageID],
      theme: { light: ThemeType.light, dark: ThemeType.dark },
    }}
  >
    {children}
  </WorkerPoolContextProvider>
)
